// extracted by mini-css-extract-plugin
export default {"container":"root_container__5mAO5","heading":"root_heading__Y29Ge"};